import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Equipment } from 'modules/Equipment/Equipment'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class EquipmentMode extends Model {
  static override entity = 'equipment_modes'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare description: string | null

  @HasMany(() => Equipment, 'equipment_id') declare equipments: Equipment[]

  @Attr(null) declare tenant_id: string
  // @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  // @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
